import * as Sentry from "@sentry/react";

export default class LogController {
    private static send(level: Sentry.SeverityLevel, message: string, contextKey: string, extraData?: Record<string, any>) {
        Sentry.withScope(scope => {
            scope.setLevel(level);
            scope.setContext(contextKey, {
                timestamp: new Date().toISOString(),
                ...extraData
            });
            scope.setTag("logLevel", level);
            scope.setTag("contextKey", contextKey);
            Sentry.captureMessage(message);
        });
    }

    static info(message: string, contextKey: string, extraData?: Record<string, any>) {
        this.send("info", message, contextKey, extraData);
    }

    static error(message: string, contextKey: string, extraData?: Record<string, any>) {
        this.send("error", message, contextKey, extraData);
    }

    static log(message: string, contextKey: string, extraData?: Record<string, any>) {
        this.send("log", message, contextKey, extraData);
    }

    static debug(message: string, contextKey: string, extraData?: Record<string, any>) {
        this.send("debug", message, contextKey, extraData);
    }

    static fatal(message: string, contextKey: string, extraData?: Record<string, any>) {
        this.send("fatal", message, contextKey, extraData);
    }

    static warning(message: string, contextKey: string, extraData?: Record<string, any>) {
        this.send("warning", message, contextKey, extraData);
    }
}